// libs
import { createContext, useContext } from 'react';

// constants
import { AUTH_STATUS } from 'shared/constants/auth';

// defs
import { Customer } from 'shared/types/customer';

interface CustomerContext {
  authStatus: AUTH_STATUS;
  customer?: Customer;
  initiateLogin: (
    redirectURL?: string,
    loginOptions?: {
      disableTruecaller?: boolean;
      forcedLogin?: boolean;
    }
  ) => void;
}

const initialValue: CustomerContext = {
  authStatus: AUTH_STATUS.NOT_DETERMINED,
  initiateLogin: () => {
    /* do nothing */
  },
};

const customerContext = createContext(initialValue);

export const useCustomerContext = () => useContext(customerContext);

export default customerContext;
